import React, {FormEvent, useState} from 'react';
import ButtonSubmit from '../../modules/form/ButtonSubmit';
import {Col, Form, Row} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {Link} from 'react-router-dom';
import {createTicketOtrs} from './api';

const FormNewAccount = (): JSX.Element => {
    const intl = useIntl();
    const [email, setEmail] = useState('');
    const [nom, setNom] = useState('');
    const [prenom, setPrenom] = useState('');
    const [compte, setCompte] = useState('');
    const [message, setMessage] = useState('');
    const [formVisible, setFormVisible] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setIsLoading(true);

        if (validateEmail(email) && nom && prenom && compte) {
            try {
                await createTicketOtrs(email, nom, prenom, compte);
                setMessage(intl.formatMessage({id: 'FORM.NEW.ACCOUNT.FORM.VALID'}));
                setEmail('');
                setNom('');
                setPrenom('');
                setCompte('');
                setFormVisible(false);
            } catch (err) {
                setMessage(intl.formatMessage({id: 'FORM.NEW.ACCOUNT.FORM_ERROR'}));
            } finally {
                setIsLoading(false);
            }
        } else {
            setMessage(intl.formatMessage({id: 'FORM.NEW.ACCOUNT.FORM.INVALID'}));
            setIsLoading(false);
        }
    };

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    return (
        <>
            {formVisible ? (
                <div className={'d-flex flex-column m-auto'}>
                    <Row className="my-5">
                        <Col>
                            <h1 className="text-celeste-primary fs-1 text-center">
                                {intl.formatMessage({id: 'FORM.NEW.ACCOUNT.TITLE_1'})}
                            </h1>
                        </Col>
                    </Row>
                    <p className="mb-5">
                        <b>{intl.formatMessage({id: 'FORM.NEW.ACCOUNT.TEXTE_GRAS'})}</b>
                        <br />
                        <i>{intl.formatMessage({id: 'FORM.NEW.ACCOUNT.TEXTE_ITALIC'})}</i>
                        <br />
                    </p>
                    <Form onSubmit={handleSubmit}>
                        <Col className="my-5 d-flex">
                            <label className="required form-label m-auto col-4">
                                {intl.formatMessage({id: 'FORM.NEW.ACCOUNT.NOM'})}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={nom}
                                placeholder={intl.formatMessage({id: 'FORM.NEW.ACCOUNT.NOM_INPUT'})}
                                onChange={(e) => setNom(e.target.value)}
                            />
                        </Col>
                        <Col className="my-5 d-flex">
                            <label className="required form-label m-auto col-4">
                                {intl.formatMessage({id: 'FORM.NEW.ACCOUNT.PRENOM'})}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={prenom}
                                placeholder={intl.formatMessage({
                                    id: 'FORM.NEW.ACCOUNT.PRENOM_INPUT',
                                })}
                                onChange={(e) => setPrenom(e.target.value)}
                            />
                        </Col>
                        <Col className="my-5 d-flex">
                            <label className="required form-label m-auto col-4">
                                {intl.formatMessage({id: 'FORM.NEW.ACCOUNT.MAIL'})}
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                placeholder="name@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Col>
                        <Col className="my-5 d-flex">
                            <label className="required form-label m-auto col-4">
                                {intl.formatMessage({id: 'FORM.NEW.ACCOUNT.COMPTE'})}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={compte}
                                placeholder={intl.formatMessage({
                                    id: 'FORM.NEW.ACCOUNT.COMPTE_INPUT',
                                })}
                                onChange={(e) => setCompte(e.target.value)}
                            />
                        </Col>
                        {message && <p className="text-danger">{message}</p>}
                        <Row>
                            <Form.Group className="justify-content-center d-flex">
                                <ButtonSubmit
                                    disabled={false}
                                    isLoading={isLoading}
                                    textId={'ADMINISTRATIVE.RECLAMATIONS.SEND'}
                                />
                            </Form.Group>
                        </Row>
                    </Form>
                </div>
            ) : (
                <div className={'m-auto'}>
                    <div>{message && <p style={{whiteSpace: 'pre-line'}}>{message}</p>}</div>
                    <div className="mb-0 mt-10">
                        <Link to="/dashboard" className="btn btn-sm btn-primary">
                            {intl.formatMessage({id: 'ERROR_PAGE.RETURN_HOME'})}
                        </Link>
                    </div>
                </div>
            )}
        </>
    );
};

export default FormNewAccount;
